import { motion } from 'framer-motion';
import styled from 'styled-components';
import { mediaMobile } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const Wrapper = styled.div`
    width: 390rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin: 0 auto;

    ${mediaMobile(`
        width: 100%;
    `)}
`;

export const Block = styled.div`
    width: 74rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    text-align: center;
`;

export const Divide = styled.sup`
    color: ${colors.white};
    font-family: FontLight;
    font-size: 20rem;
    margin-top: 8rem;

`;

export const Number = styled(motion.p)`
    width: 100%;
    color: ${colors.white};
    font-family: FontLight;
    font-size: 50rem;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    
    ${mediaMobile(`
        font-size: 32rem;
    `)}
`;
export const Label = styled(motion.span)`
    width: 100%;
    color: ${colors.white};
    font-family: FontRegular;
    font-size: 16rem;
    text-shadow: 0px 0px 8px rgba(0, 0, 0, 0.3);
    
    ${mediaMobile(`
        font-size: 8rem;
    `)}
`;
